'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$() {
  this.aSB = null;
  this.aSS = null;
  this.aSE = null;
  this.aSF = false;
  this.aSK = null;
  this.aSL = false;
  this.aSQ = null;
  this.aSR = false;
  this.aSC = null;
  this.aSD = false;
  this.aSO = null;
  this.aSP = false;
  this.aSM = null;
  this.aSN = false;
  this.aSG = null;
  this.aSH = false;
  this.aSI = null;
  this.aSJ = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ = this;
  this.aSB = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$();
  this.aSS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$.prototype = $p;
$p.eR = (function() {
  return this.aSB;
});
$p.eO = (function() {
  return this.aSS;
});
$p.bW = (function() {
  if ((!this.aSF)) {
    this.aSE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aSF = true;
  }
  return this.aSE;
});
$p.b9 = (function() {
  if ((!this.aSL)) {
    this.aSK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aSL = true;
  }
  return this.aSK;
});
$p.b3 = (function() {
  if ((!this.aSR)) {
    this.aSQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aSR = true;
  }
  return this.aSQ;
});
$p.aG = (function() {
  if ((!this.aSD)) {
    this.aSC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aSD = true;
  }
  return this.aSC;
});
$p.az = (function() {
  if ((!this.aSP)) {
    this.aSO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aSP = true;
  }
  return this.aSO;
});
$p.aY = (function() {
  if ((!this.aSN)) {
    this.aSM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aSN = true;
  }
  return this.aSM;
});
$p.afn = (function() {
  if ((!this.aSH)) {
    this.aSG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Usuance";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aSH = true;
  }
  return this.aSG;
});
$p.bNK = (function() {
  if ((!this.aSJ)) {
    this.aSI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().zt;
    this.aSJ = true;
  }
  return this.aSI;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$, "app.data.data_point_types$package$UsuanceForm$", ({
  GD: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$() {
  this.aSz = null;
  this.aSA = false;
  this.aSx = null;
  this.aSy = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$.prototype = $p;
$p.aA = (function() {
  if ((!this.aSA)) {
    this.aSz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aSA = true;
  }
  return this.aSz;
});
$p.bNj = (function() {
  if ((!this.aSy)) {
    this.aSx = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$UsuanceForm$().afn();
    this.aSy = true;
  }
  return this.aSx;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$, "app.data.data_point_types$package$Usuance$", ({
  GC: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Usuance$ };
//# sourceMappingURL=app.data.data_point_types$package$-Usuance$.js.map
